const e = "styles-module__container___NXVS7", _ = "styles-module__slide___5tuva", s = {
  container: e,
  slide: _,
  "slide--next": "styles-module__slide--next___KulMY",
  "slide--prev": "styles-module__slide--prev___vMFMm",
  "image-container": "styles-module__image-container___hlMld",
  "image-index": "styles-module__image-index___6sJOL"
};
export {
  e as container,
  s as default,
  _ as slide
};
